import { EMAILS_REGEXP } from '@/regExp';

const findEmailInString = (input: string): string[] | null => {
    const entries = input.match(EMAILS_REGEXP);
    return entries ? [...(new Set(entries))] : null;
};

export default findEmailInString;
